module.exports = __webpack_public_path__ + "img/offer1.c90774d9.png";